import type { PositionGuideConfig, PositionGuideKey } from './photoGuidelines.types';

export const getPositionConfig = (imageHeight: number): Record<PositionGuideKey, PositionGuideConfig> => ({
  front: {
    head: {
      connectorLine: { width: imageHeight * 0.41, marginLeft: -(imageHeight * 0.39), marginTop: -(imageHeight * 0.68) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginTop: -(imageHeight * 0.68) },
      text: { marginTop: -(imageHeight * 0.70) },
    },
    torso: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.32), marginTop: -(imageHeight * 0.25) },
      lineDot: { marginTop: -(imageHeight * 0.25), marginLeft: -(imageHeight * 0.037) },
      text: { marginTop: -(imageHeight * 0.25) },
    },
    arms: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.32), marginBottom: -(imageHeight * 0.09) },
      lineDot: { marginLeft: -(imageHeight * 0.037), marginBottom: -(imageHeight * 0.09) },
      text: { marginBottom: -(imageHeight * 0.09) },
    },
    feet: {
      connectorLine: { width: imageHeight * 0.39, marginLeft: -(imageHeight * 0.37), marginBottom: -(imageHeight * 0.75) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginBottom: -(imageHeight * 0.75) },
      text: { marginBottom: -(imageHeight * 0.75) },
    },
  },
  back: {
    head: {
      connectorLine: { width: imageHeight * 0.41, marginLeft: -(imageHeight * 0.39), marginTop: -(imageHeight * 0.60) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginTop: -(imageHeight * 0.60) },
      text: { marginTop: -(imageHeight * 0.60) },
    },
    torso: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.32), marginTop: -(imageHeight * 0.20) },
      lineDot: { marginTop: -(imageHeight * 0.20), marginLeft: -(imageHeight * 0.037) },
      text: { marginTop: -(imageHeight * 0.20) },
    },
    arms: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.32), marginBottom: -(imageHeight * 0.06) },
      lineDot: { marginLeft: -(imageHeight * 0.037), marginBottom: -(imageHeight * 0.06) },
      text: { marginBottom: -(imageHeight * 0.06) },
    },
    feet: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.32), marginBottom: -(imageHeight * 0.66) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginBottom: -(imageHeight * 0.66) },
      text: { marginBottom: -(imageHeight * 0.66) },
    },
  },
  right_side: {
    head: {
      connectorLine: { width: imageHeight * 0.35, marginLeft: -(imageHeight * 0.35), marginTop: -(imageHeight * 0.61) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginTop: -(imageHeight * 0.61) },
      text: { marginTop: -(imageHeight * 0.61) },
    },
    torso: {
      connectorLine: { width: imageHeight * 0.22, marginLeft: -(imageHeight * 0.22), marginTop: -(imageHeight * 0.38) },
      lineDot: { marginTop: -(imageHeight * 0.38), marginLeft: -(imageHeight * 0.03) },
      text: { marginTop: -(imageHeight * 0.26) },
    },
    arms: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.34), marginTop: -(imageHeight * 0) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginTop: -(imageHeight * 0) },
      text: { marginTop: 0 },
    },
    feet: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.34), marginBottom: -(imageHeight * 0.68) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginBottom: -(imageHeight * 0.68) },
      text: { marginBottom: -(imageHeight * 0.68) },
    },
  },
  left_side: {
    head: {
      connectorLine: { width: imageHeight * 0.36, marginLeft: -(imageHeight * 0.36), marginTop: -(imageHeight * 0.65) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginTop: -(imageHeight * 0.65) },
      text: { marginTop: -(imageHeight * 0.65) },
    },
    torso: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.34), marginTop: -(imageHeight * 0.30) },
      lineDot: { marginTop: -(imageHeight * 0.30), marginLeft: -(imageHeight * 0.03) },
      text: { marginTop: -(imageHeight * 0.20) },
    },
    arms: {
      connectorLine: { width: imageHeight * 0.34, marginLeft: -(imageHeight * 0.34), marginBottom: -(imageHeight * 0) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginBottom: -(imageHeight * 0) },
      text: { marginBottom: -(imageHeight * 0) },
    },
    feet: {
      connectorLine: { width: imageHeight * 0.41, marginLeft: -(imageHeight * 0.41), marginBottom: -(imageHeight * 0.75) },
      lineDot: { marginLeft: -(imageHeight * 0.03), marginBottom: -(imageHeight * 0.75) },
      text: { marginBottom: -(imageHeight * 0.75) },
    },
  },
});
